export default "__VITE_ASSET__6e77cb6e__"